var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPlaybutton = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
    stroke: "#3953FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7.2688C7.75 6.83924 7.75 6.62446 7.83977 6.50456C7.918 6.40007 8.03774 6.33469 8.16794 6.32539C8.31734 6.31472 8.49801 6.43086 8.85934 6.66315L13.1079 9.39435C13.4214 9.59592 13.5782 9.6967 13.6323 9.82485C13.6797 9.93682 13.6797 10.0632 13.6323 10.1751C13.5782 10.3033 13.4214 10.4041 13.1079 10.6056L8.85935 13.3368C8.49801 13.5691 8.31734 13.6853 8.16794 13.6746C8.03774 13.6653 7.918 13.5999 7.83977 13.4954C7.75 13.3755 7.75 13.1608 7.75 12.7312V7.2688Z",
    stroke: "#3953FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlaybutton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Playbutton.d6520cf0.svg";
export { ForwardRef as ReactComponent };